import React, { useEffect, useState } from "react";

// Doctor data
const doctors = [
  {
    name: "Dr. Aisha Sharma",
    type: "Cardiologist",
    image: "doc3.jpg",
    details: "Specializes in heart health and cardiovascular diseases.",
  },
  {
    name: "Dr. Raj Mehta",
    type: "Neurologist",
    image: "doc3.jpg",
    details: "Expert in disorders of the nervous system.",
  },
  {
    name: "Dr. Lina Verma",
    type: "Dermatologist",
    image: "doc1.jpg",
    details: "Focuses on skin, hair, and nail conditions.",
  },
  {
    name: "Dr. Imran Khan",
    type: "Orthopedic",
    image: "doc1.jpg",
    details: "Deals with musculoskeletal system issues.",
  },
  {
    name: "Dr. Sneha Patil",
    type: "Pediatrician",
    image: "doc4.jpg",
    details: "Provides medical care for infants, children, and adolescents.",
  },
  {
    name: "Dr. Arjun Rao",
    type: "Urologist",
    image: "doc1.jpg",
    details: "Specializes in the urinary tract and male reproductive system.",
  },
  {
    name: "Dr. Riya Das",
    type: "Gynecologist",
    image: "doc1.jpg",
    details: "Focuses on women's reproductive health.",
  },
  {
    name: "Dr. Aman Singh",
    type: "ENT Specialist",
    image: "doc1.jpg",
    details: "Deals with ear, nose, and throat disorders.",
  },
];

const DoctorSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(5);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Handle responsive card count
  const updateVisibleCards = () => {
    if (window.innerWidth < 480) setVisibleCards(1);
    else if (window.innerWidth < 768) setVisibleCards(2);
    else setVisibleCards(5);
  };

  useEffect(() => {
    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  // Auto-slide every 3s when not hovering
  useEffect(() => {
    if (hoveredIndex === null) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % doctors.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [hoveredIndex]);

  const sliderContainerStyle = {
    width: "100%",
    overflow: "hidden",
    padding: "30px 10px",
    background: "#f9f9f9",
    textAlign: "center",
    position: "relative", // For positioning the navigation icons
  };

  const titleStyle = {
    fontSize: "2.5rem",
    marginBottom: "25px",
    fontFamily: "Poppins, sans-serif",
  };

  const sliderWrapperStyle = {
    overflow: "hidden",
    width: "100%",
  };

  const getSlideStyle = () => {
    const widthPercent = 100 / visibleCards;
    return {
      width: `${(doctors.length * 100) / visibleCards}%`,
      transform: `translateX(-${(currentIndex * 100) / doctors.length}%)`,
      display: "flex",
      transition: "transform 0.6s ease-in-out",
    };
  };

  const cardHeight = "350px";

  const getCardContainerStyle = (index) => ({
    width: `${100 / doctors.length}%`,
    flexShrink: 0,
    padding: "15px",
    boxSizing: "border-box",
    transformStyle: "preserve-3d",
    transform: hoveredIndex === index ? "rotateY(180deg)" : "rotateY(0deg)",
    transition: "transform 0.4s ease-in-out",
    cursor: "pointer",
    height: cardHeight,
  });

  const frontCardStyle = {
    background: "#fff",
    borderRadius: "15px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
    padding: "20px",
    textAlign: "center",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backfaceVisibility: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  const backCardStyle = {
    background: "#eee",
    borderRadius: "15px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
    padding: "25px",
    textAlign: "center",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backfaceVisibility: "hidden",
    transform: "rotateY(180deg)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  };

  const doctorImageStyle = {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    marginBottom: "15px",
    objectFit: "cover",
  };

  const doctorNameStyle = {
    margin: "15px 0 8px",
    fontSize: "1.5rem",
    fontWeight: "600",
  };

  const doctorTypeStyle = {
    margin: 0,
    color: "#666",
    fontSize: "1.1rem",
    fontFamily: "'Great Vibes', cursive",
  };

  const doctorDetailsStyle = {
    marginTop: "20px",
    fontSize: "1rem",
    color: "#333",
  };

  const navIconStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(0, 0, 0, 0.1)",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    padding: "10px",
    fontSize: "1.5rem",
    cursor: "pointer",
    zIndex: 10,
    opacity: 0.7,
    transition: "opacity 0.3s ease",
  };

  const prevButtonStyle = {
    left: "10px",
  };

  const nextButtonStyle = {
    right: "10px",
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? doctors.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % doctors.length);
  };

  return (
    <div style={sliderContainerStyle}>
      <h2 style={titleStyle}>Meet Our Doctors</h2>
      <div style={sliderWrapperStyle}>
        <div style={getSlideStyle()}>
          {doctors.map((doc, idx) => (
            <div
              key={idx}
              style={getCardContainerStyle(idx)}
              onMouseEnter={() => setHoveredIndex(idx)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div style={frontCardStyle}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={doctorImageStyle}
                />
                <h4 style={doctorNameStyle}>{doc.name}</h4>
                <p style={doctorTypeStyle}>{doc.type}</p>
              </div>
              <div style={backCardStyle}>
                <h4 style={doctorNameStyle}>{doc.name}</h4>
                <p style={doctorTypeStyle}>{doc.type}</p>
                <p style={doctorDetailsStyle}>{doc.details}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button style={{ ...navIconStyle, ...prevButtonStyle }} onClick={goToPrevious}>
        &lt;
      </button>
      <button style={{ ...navIconStyle, ...nextButtonStyle }} onClick={goToNext}>
        &gt;
      </button>
    </div>
  );
};

export default DoctorSlider;